import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { LiftErrorService } from './lift-error.service';
import { LiftErrorCriteria } from '../models/lift-error.criteria';

@Injectable({ providedIn: 'root' })
export class LiftErrorResolver implements Resolve<any> {
  constructor(
    private liftErrorService: LiftErrorService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    const liftId = route.params.id;
    const params: HttpParams = new LiftErrorCriteria().paramsExport();

    return this.liftErrorService.get(params, liftId);
  }
}
